module.exports = __webpack_public_path__ + "img/sunset_woman.45df0d2c.jpeg";